import { Helmet } from "react-helmet";
import Navbar from "../components/universal/navbar";
import Header from "../components/terms-of-use/hero";
import PP from "../components/terms-of-use/content";
import CTA from "../components/universal/cta";
import Contact from "../components/universal/contact";
import Footer from "../components/universal/footer";

function Index() {
  return (
    <div>
      <Helmet>
        <title>Terms of Use | Composite Bonding Ilkley Website</title>
        <link
          rel="canonical"
          href="https://www.compositebonding-ilkley.com/terms-of-use"
        />
        <meta
          name="description"
          content="Review the Terms of Use for Regent Dental, proudly serving Ilkley and Keighley—learn how we keep your experience clear, safe, and confident online."
        />
      </Helmet>
      <Navbar />
      <Header />
      <PP />
      <CTA />
      <Contact />
      <Footer />
    </div>
  );
}

export default Index;
